import { useEffect, useRef } from "react";

export default function EmberCanvas() {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const spawn = (anywhere) => ({
      x: Math.random() * (w || 1200),
      y: anywhere ? Math.random() * (h || 800) : (h || 800) + 12,
      r: Math.random() * 1.8 + 0.4,
      vy: Math.random() * 0.55 + 0.25,
      sway: Math.random() * 1.4 + 0.4,
      phase: Math.random() * Math.PI * 2,
      hue: Math.random() < 0.7 ? 14 + Math.random() * 20 : 44,
      a: Math.random() * 0.45 + 0.25,
    });

    const resize = () => {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const parts = Array.from({ length: 90 }, () => spawn(true));
    let t = 0;
    const draw = () => {
      t += 0.016;
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.y -= p.vy;
        p.x += Math.sin(t * p.sway + p.phase) * 0.3;
        if (p.y < -14) Object.assign(p, spawn(false));
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
        g.addColorStop(0, `hsla(${p.hue}, 100%, 60%, ${p.a})`);
        g.addColorStop(1, "transparent");
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      className="absolute inset-0 z-[5] h-full w-full opacity-80"
    />
  );
}
